var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper document-view-details"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "document-view-body"
  }, [_vm._m(1), _c('div', {
    staticClass: "directory-block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.data.user_info.first_name) + " " + _vm._s(_vm.data.user_info.last_name))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.data.user_info.address1))]), _c('li', [_vm._v(_vm._s(_vm.data.user_info.city) + ", " + _vm._s(_vm.data.user_info.state) + " " + _vm._s(_vm.data.user_info.zip))])])]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("November 24th, 2025")]), _vm._m(2), _c('p', [_vm._v("As of January 1st, 2026, the "), _c('strong', [_vm._v(_vm._s(this.planName))]), _vm._v(" plans will be renewed. There is nothing you need to do on your end as the renewal is automatic. This is just a formal notification of the rate change for 2026. ")]), _c('p', [_vm._v("Billing will be adjusted accordingly on your upcoming Statement or Electronic Payment (EFT).")]), _c('br'), _vm._m(3), _vm.updatedPlans.length ? _c('div', _vm._l(_vm.updatedPlans, function (plan, index) {
    return _c('div', {
      key: index,
      staticClass: "new-rate-details"
    }, [_c('ul', [_c('li', [_vm._v("Plan: "), _c('strong', [_vm._v(_vm._s(plan.planName))])]), _c('li', [_vm._v("Tier: "), _c('strong', [_vm._v(_vm._s(plan.tierInfo))])]), _c('li', [_vm._v("New Rate: "), _c('strong', [_vm._v("$" + _vm._s(plan.newRate))])])])]);
  }), 0) : _vm._e(), _vm._m(4), _vm._m(5), _c('br'), _c('br'), _vm._m(6)])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Document View Details")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('img', {
    staticClass: "elevate-logo",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "src": require("@/assets/images/darknuera.png")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('strong', [_vm._v("Dear Valued Member,")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('strong', [_vm._v("Your new rate for your benefit plan as of January 1st, 2026 will be as follows:")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "osf"
  }, [_c('em', [_vm._v("This new rate will be effective until the next renewal on "), _c('strong', [_vm._v("December 31st, 2026.")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "osf"
  }, [_c('em', [_vm._v("If you have any questions, you may contact your representative or broker.")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "doc-footer"
  }, [_c('p', [_c('strong', [_vm._v("Sincerely,")])]), _c('p', {
    staticClass: "osf"
  }, [_vm._v("NuEra Billing Services")])]);
}]

export { render, staticRenderFns }